import { useSelector } from "react-redux";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

import { selectDocument } from "../../../store/documentSignerShow/selectors/selectDocument";
import { DocumentViewer } from "../../../components/DocumentViewer";
export const DocumentInfo: React.FC = () => {
  const document = useSelector(selectDocument);

  return <DocumentViewer document={document}></DocumentViewer>;
};
